/**
 * Type guard for a non-empty, parseable date string (e.g. a license end date).
 * Returns `false` for nullish or unparseable values, and narrows the argument
 * to `string` when `true`.
 *
 * @param endDate The date (ISO or date string), or a nullish/invalid value.
 */
export function hasValidEndDate(endDate?: string | null): endDate is string {
  if (!endDate) {
    return false;
  }

  return !Number.isNaN(new Date(endDate).getTime());
}
